export default "__VITE_ASSET__Bz6guaN3__"